import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http'
import { Resource } from '@opentelemetry/resources'
import { LoggerProvider, LoggerProviderConfig, SimpleLogRecordProcessor } from '@opentelemetry/sdk-logs'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'

export function initializeLogging(): LoggerProvider {
  try {
    const logConfig: LoggerProviderConfig = {
      resource: new Resource({
        [ATTR_SERVICE_NAME]: 'datable-ui',
      }),
    }

    const logProvider = new LoggerProvider(logConfig)

    const otlpLogExporter = new OTLPLogExporter({
      url: import.meta.env.DEV ? 'http://127.0.0.1:4318/v1/logs' : 'https://monitor.dtbl.io:4318/v1/logs',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    logProvider.addLogRecordProcessor(new SimpleLogRecordProcessor(otlpLogExporter))

    console.log('Logging initialized')

    return logProvider
  } catch (e) {
    console.error('Error initializing logging, returning default LoggerProvider:', e)

    // Return a basic LoggerProvider even in case of an error
    return new LoggerProvider()
  }
}

export const logs = initializeLogging()
